import { Stack } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import type { ReactNode } from 'react';

export const ButtonContainer = ({ children }: { children: ReactNode }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Stack
        sx={{
          flexDirection: 'row',
          alignSelf: 'flex-start',
          justifyContent: 'space-between',
          width: '100%',
          backgroundColor: 'common.white',
          position: 'sticky',
          bottom: 0,
          borderTop: (t) => `1px solid ${t.palette.other.outlineBorder}`,
          p: 2,
          gap: 2,
        }}
      >
        {children}
      </Stack>
    );
  }

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignSelf: 'flex-end',
        width: 'fit-content',
        gap: 2,
      }}
    >
      {children}
    </Stack>
  );
};
